import { c as _c } from "react/compiler-runtime";
import React, { ReactNode, useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import ChevronUpIcon from '@/assets/icons/heroIcons/Chevron-down.svg';
import { motion } from 'framer-motion';
import { mergeClasses } from '@/utils/style';
import { LINKS } from '@/constants/links';
type BgColorType = 'bg-white' | 'bg-blue-50' | 'bg-blue-100';
export type FAQItemType = {
  question: string;
  answer: string | ReactNode;
};
export function FAQItem(t0) {
  const $ = _c(28);
  const {
    item,
    bgColor
  } = t0;
  const [isActive, setIsActive] = useState(false);
  const answerId = useId();
  const t1 = bgColor || "bg-white";
  let t2;
  if ($[0] !== t1) {
    t2 = mergeClasses("shadow-card rounded-2xl", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsActive(_temp);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = mergeClasses("flex w-full cursor-pointer flex-row items-center justify-between overflow-hidden p-4 text-left md:p-6");
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== item.question) {
    t5 = <h2 className="text-sm font-semibold whitespace-normal text-gray-900 md:text-base">{item.question}</h2>;
    $[4] = item.question;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      rotateX: 0
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isActive ? 180 : 0;
  let t8;
  if ($[7] !== t7) {
    t8 = {
      rotateX: t7
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronUpIcon className={mergeClasses("min-h-6 min-w-6 text-blue-500")} aria-hidden="true" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <motion.div initial={t6} animate={t8}>{t9}</motion.div>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== answerId || $[13] !== isActive || $[14] !== t10 || $[15] !== t5) {
    t11 = <button onClick={t3} aria-expanded={isActive} aria-controls={answerId} className={t4}>{t5}{t10}</button>;
    $[12] = answerId;
    $[13] = isActive;
    $[14] = t10;
    $[15] = t5;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = isActive ? "open" : "collapsed";
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== item.answer) {
    t14 = <div className="px-4 pb-4 text-sm whitespace-normal md:px-6 md:pb-6 md:text-base">{item.answer}</div>;
    $[18] = item.answer;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== answerId || $[21] !== t12 || $[22] !== t14) {
    t15 = <motion.section id={answerId} key="content" initial="collapsed" animate={t12} exit="collapsed" variants={t13} className="w-full overflow-hidden" role="region" aria-labelledby={answerId}>{t14}</motion.section>;
    $[20] = answerId;
    $[21] = t12;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t11 || $[25] !== t15 || $[26] !== t2) {
    t16 = <div className={t2}>{t11}{t15}</div>;
    $[24] = t11;
    $[25] = t15;
    $[26] = t2;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
}
function _temp(prevState) {
  return !prevState;
}
export function FAQs(t0) {
  const $ = _c(17);
  const {
    bgColor,
    data,
    buttonLabel,
    hideButton,
    className
  } = t0;
  const {
    t
  } = useTranslation("core");
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("mt-6 flex flex-col gap-2 md:mt-8", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bgColor || $[3] !== data) {
    let t3;
    if ($[5] !== bgColor) {
      t3 = (item, i) => <FAQItem key={i} item={item} bgColor={bgColor} />;
      $[5] = bgColor;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = data.map(t3);
    $[2] = bgColor;
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== buttonLabel || $[11] !== hideButton || $[12] !== t) {
    t4 = !hideButton && <Button variant="secondary" testId="seoFAQsMoreFAQs" analyticsParam="seoFAQsMoreFAQs" to={LINKS().faq}>{buttonLabel ?? t("faqs.button")}</Button>;
    $[10] = buttonLabel;
    $[11] = hideButton;
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}